import actions from '../../store/actions'
import { SignInByEmailRequest, TokenResponse } from '../../resources/auth/types'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'

export const useSignInByEmail = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const signInByEmail = (payload: SignInByEmailRequest): Promise<TokenResponse> => {
        setInProgress(true)
        return mutations
            .signInByEmail(payload)
            .then(({ data }) => {
                setInProgress(false)
                if (data) {
                    dispatch(actions.signIn(data))
                    return data
                }
                throw generateError()
            })
            .catch((error) => {
                setInProgress(false)
                dispatch(actions.signOut())
                throw generateError(error)
            })
    }

    return {
        signInByEmail,
        inProgress,
    }
}
